import { render } from "./OrderDetailView.vue?vue&type=template&id=cc449f78&scoped=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=js"
export * from "./OrderDetailView.vue?vue&type=script&lang=js"

import "./OrderDetailView.vue?vue&type=style&index=0&id=cc449f78&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc449f78"]])

export default __exports__